export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          Asia Rugby U-20 7s Championship 2025
        </h3>
        <br />
        <p className="card-text">
          A golden chapter is about to be written in the history of Bihar! For
          the first time ever, the ancient city of Rajgir will proudly host the
          prestigious Asia Rugby U20 Sevens Championship 2025 on 9th and 10th
          August. This grand tournament will not only bring Bihar’s rich
          sporting culture to the global stage but also mark a new milestone in
          Asia’s rugby landscape.
        </p>
        <br />
        <p>
          A total of nine countries are going to participate in the Asia Rugby
          U20 Sevens Championship, with 16 teams — 8 men’s and 8 women’s squads
          — competing for top honours. The championship will feature teams from
          top-ranked Asian nations such as India, Hong Kong, China, UAE,
          Uzbekistan, Kazakhstan, Sri Lanka, Malaysia (men only), and Nepal
          (women only).
        </p>
        <p>
          From 7th August, all participating teams will begin arriving in
          Rajgir, where they’ll experience the warmth of Bihar’s legendary
          hospitality. On 8th August, a grand opening ceremony will be held at
          the Kabaddi Hall in the Rajgir Sports Complex, adding glamour and
          grandeur to the occasion.
        </p>
        <br />
        <p>
          All teams will be accommodated in Rajgir itself, creating a vibrant
          confluence of local culture and international rugby. Out of the 32
          rugby-playing nations in Asia, only the top 8 ranked teams are
          selected for this championship — highlighting its prestige and
          exclusivity.
        </p>
        <br />
        <p>
          This event is a moment of pride for Bihar, where rugby is one of the
          14 priority sports. Players from Bihar will represent India in this
          tournament, showcasing their skill and determination. Recently,
          Bihar’s women’s team won silver at the National Games, and its boys'
          and girls' teams were crowned champions across junior, sub-junior, and
          senior categories at the School Games — underlining Bihar’s growing
          dominance in the sport.
        </p>
        <br />
        <p>
          The championship will provide Bihar’s rising rugby stars with a global
          platform, inspire youth across the state, and strengthen the
          foundation of sports in the region. This historic event in Rajgir is
          set to become a milestone in Bihar’s sporting journey, elevating the
          state’s identity on the world stage.
        </p>
        <br />
      </div>
    </div>
  );
}
